import { Button } from '@/components/ui/button';
import { InternalServerErrorIcon } from '@/icons';

const VisualError = ({ height, onClick }: { height: number; onClick?: () => void }) => {
  return (
    <div
      className='flex w-full flex-col items-center justify-center rounded-t-none rounded-b-md'
      style={{ height: `${height}px` }}
    >
      <div className='flex h-full flex-col items-center px-16 py-8'>
        <InternalServerErrorIcon className='tablet:h-64 mobile:h-56 h-96' />
        <h1 className='text-xl'>Hoppsan! Något gick fel.</h1>
        <p className='text-md mobile:text-sm my-4'>
          Graferna kunde inte laddas. Ofta beror detta på stora sökningar, prova ställa fråga igen och se om det går
          bättre.
        </p>
        {onClick && <Button onClick={onClick}>Ladda om</Button>}
      </div>
    </div>
  );
};

export default VisualError;
